import Vue from 'vue'
import api from '../api/general'

const mixins = Vue.mixin({
    data: () => ({
        allowedFileSize: 128, // MB
        tier_loading: true,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        deep_archive_limit_date: process.env.MIX_DEEP_ARCHIVE_LIMIT_DATE || '2022-01-01',
        poi_deep_archive_limit_date: process.env.MIX_POI_DEEP_ARCHIVE_LIMIT_DATE || '2023-01-01',
        docs_url: process.env.MIX_DOCS_WEBSITE_DATASTREAM_URL || 'https://docs.intuizi.com/knowledge-base/category/data-stream',
        activations_history_url: process.env.MIX_ACTIVATIONS_HISTORY_REDIRECT_URL || '/data-explorer/analyses/activation-history',
        my_pois_url: process.env.MIX_FRONTEND_MY_POIS_URL || '/admin/pois/my-pois',
        taxonomies_url: process.env.MIX_FRONTEND_TAXONOMIES_URL || '/admin/pois/taxonomies',
        data_streams_url: process.env.MIX_DATASTREAMS_ROUTE_URL || '/data-explorer/visualization/datastreams',
        cohorts_url: process.env.MIX_FRONTEND_COHORTS_URL || '/data-explorer/analyses/cohorts',
        orders: [{value: 'asc', text: 'ASC'}, {value: 'desc', text: 'DESC'}],
        perPage: [
            {
                value: 25,
                text: '25'
            },
            {
                value: 50,
                text: '50'
            },
            {
                value: 100,
                text: '100'
            },
            {
                value: 250,
                text: '250'
            },
        ],
        abnormality_types: [{value: 2, text: 'Normal'}, {value: 1, text: 'All'}],
        day_hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        distance_units: ['miles', 'meters'],
        total_meters_in_one_mile: 1609.344,
        colors: {
            ad_toggle: 'rgba(153,76,0,1)',
            ad_bg: 'rgba(153,76,0,0.05)',
            cv_toggle: 'rgba(102,102,255,1)',
            cv_bg: 'rgba(102,102,255,0.05)',
            ca_toggle: 'rgba(153,0,76,1)',
            ca_bg: 'rgba(153,0,76,0.05)',
            fq_toggle: 'rgba(0,153,0,1)',
            fq_bg: 'rgba(0,153,0,0.05)',
            ds_toggle: 'rgba(153,0,76,1)',
            ds_bg: 'rgba(153,0,76,0.05)',
        }
    }),
    methods: {
        getBadgeStatusClassName(color_name) {
            return 'badge-' + color_name
        },
        getRandomString() {
            return Math.random().toString(36).slice(2, 12)
        },
        statusToString(status) {
            switch (status) {
                case 0:
                    return "Processing"
                    break
                case 1:
                    return "Analyzing"
                    break
                case 2:
                    return "Completed"
                    break

                default:
                    return "Processing"
                    break
            }
        },
        copyToClipboard(uri) {
            navigator.clipboard.writeText(uri)
            this.$toast.open({
                message: "Copied to clipboard!",
                type: "info",
            })
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        async fetchUserPermissions() {
            await api.getUserPermissions({
                _token: $('meta[name="_token"]').attr('content'),
            })
            .then(res => {
                this.permissions = res.data
            })
        },
        async logUser() {
            await api.logUser()
                .then(res => {
                    if (res.data === 'success') {
                        location.reload()
                    } else {
                        document.location.href = 'https://' + window.location.hostname + '/logout'
                    }
                })
        },
        async fetchUser() {
            await api.getUser()
                .then(res => {
                    this.user_id = res.data.id
                    this.company_id = res.data.company_id
                    this.notifications_preferences = res.data.notifications
                    this.is_power_user = !!res.data.is_power_user
                })
                .catch(e => {
                    if (e.response.status === 401) {
                        this.logUser()
                    }
                })
        },
        async fetchTierInfo() {
            await api.getTierInfo()
                .then(res => {
                    this.tierStatus.pois = res.data.data.pois
                    this.tierStatus.brands = res.data.data.brands
                    this.tierStatus.categories = res.data.data.categories

                    this.tier.pois = res.data.limits.pois
                    this.tier.brands = res.data.limits.brands
                    this.tier.categories = res.data.limits.categories
                })
        },
        nthDate(date) {
            if (date > 3 && date < 21) return 'th';
            switch (date % 10) {
                case 1:  return "st";
                case 2:  return "nd";
                case 3:  return "rd";
                default: return "th";
            }
        },
        checkObject(data) {
            if (Object.keys(data).length && data.constructor === Object) {
                return true
            } else {
                return false
            }
        },
        getPreviousSunday(date = new Date()) {
            // If today is Sunday - set the previous Sunday
            if (date.getDay() === 0) {
                date.setDate(date.getDate() - 7);
            }

            // Get the last Sunday
            date.setDate(date.getDate() - date.getDay());

            return date;
        },
        isUSASelected(countries) {
            return countries.indexOf('USA', countries) != -1
        },
        locationsIdsValidation(v) {
            if (v.length > 0) {
                const tmp = v.split("\n")
                let fail = ''
                let status = true
                tmp.forEach(function (item, index) {
                    if (!/^[0-9 ]*$/.test(item)) {
                        fail = index + 1
                        status = false
                    } else {
                        return true
                    }
                })

                return (status) ? true : 'Location ID on row ' + fail + ' is invalid'

            } else {
                return true
            }
        },
        bundleIdsValidation(v) {
            if (v.length > 0) {
                const tmp = v.split("\n")
                let fail = ''
                let status = true
                tmp.forEach(function (item, index) {
                    if (!/^[0-9A-Za-z._]*$/.test(item)) {
                        fail = index + 1
                        status = false
                    } else {
                        return true
                    }
                })

                return (status) ? true : 'Bundle ID on row ' + fail + ' is invalid'

            } else {
                return true
            }
        },
        mergeLocationIds() {
            if (this.insert_custom_locations_0 && this.location_ids_0 !== '') {
                let locationIds = this.location_ids_0.split("\n").map( Number )
                this.conc_locations_0 = [...new Set(this.locations_0.concat(locationIds))]
            } else {
                this.conc_locations_0 = this.locations_0
            }

            if (this.insert_custom_locations_1 && this.location_ids_1 !== '') {
                let locationIds = this.location_ids_1.split("\n").map( Number )
                this.conc_locations_1 = [...new Set(this.locations_1.concat(locationIds))]
            } else {
                this.conc_locations_1 = this.locations_1
            }

            if (this.insert_custom_locations_cross && this.location_ids_cross !== '') {
                let locationIds = this.location_ids_cross.split("\n").map( Number )
                this.conc_locations_cross = [...new Set(this.locations_cross.concat(locationIds))]
            } else {
                this.conc_locations_cross = this.locations_cross
            }
        },
        unitChanged(order) {
            if (this.$data['distance_limits_unit_' + order] === 'meters') {
                this.$data['distance_limits_' + order] = (this.$data['distance_limits_' + order] * this.total_meters_in_one_mile).toFixed(3)
            } else if (this.$data['distance_limits_unit_' + order] === 'miles') {
                this.$data['distance_limits_' + order] = (this.$data['distance_limits_' + order] / this.total_meters_in_one_mile).toFixed(3)
            }
        },
        toggle(name, index) {
            if (this.showedData === name + '_' + index) {
                this.showedData = undefined
            } else {
                this.showedData = name + '_' + index
            }
        },
        showHideValue(item, index) {
            let label = item + '_' + index
            if (this.showedData.includes(label)) {
                return '<i class="far fa-minus-square"></i>'
            } else {
                return '<i class="far fa-plus-square"></i>'
            }
        },
        getActivationQueryValue(activation) {
            return "<strong>Query Operator: </strong>" + activation.query
        },
        getIdentifierByPricingModel(pricing_model) {
            let identifier = 'EID'
            if (pricing_model.includes('MAID')) {
                identifier = 'MAID'
            } else if (pricing_model.includes('EID')) {
                identifier = 'EID'
            } else if (pricing_model.includes('IP')) {
                identifier = 'IP'
            }

            return identifier
        },
        getIdentifierPrefixByPricingModel(pricing_model) {
            let prefix = ''
            if (pricing_model.includes('MAID')) {
                prefix = 'Decrypted'
            } else if (pricing_model.includes('IP')) {
                prefix = 'Mapped'
            }

            return prefix
        }
    },
    computed: {
        isMobile() {
            if (window.innerWidth <= 768) {
                return 'push-10'
            } else {
                return 'push-20'
            }
        },
        timeNow() {
            const time = new Date();
            return time.toJSON().slice(11,16)
        },
        primaryColor() {
            return this.$store.getters.getPrimaryColor
        }
    }

})

export default mixins